const dataSelectCaretUp = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="4.5 9.75 8 6.25 11.5 9.75"/></svg>',
};

export { dataSelectCaretUp as default };
